"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Custom filter for creation from base portfolio of types categories.
 */
var BasePortfolioTypeSubTypeFilterService = /** @class */ (function () {
    function BasePortfolioTypeSubTypeFilterService() {
    }
    return BasePortfolioTypeSubTypeFilterService;
}());
exports.BasePortfolioTypeSubTypeFilterService = BasePortfolioTypeSubTypeFilterService;
//# sourceMappingURL=base-portfolio-type-sub-type-filter.service.js.map